export default "__VITE_ASSET__wwO9gyJT__"